import { observable, computed, action } from "mobx";
import { ROUTE_FROM_PEGNI, ROUTE_FROM_PEGNI_CERTIFICATI,ROUTE_FROM_UNIMODWEB, ROUTE_FROM_CANCELLAZIONI_IPOTECA,ROUTE_RICEVUTE, ROUTE_RICEVUTE_DETTAGLIO, ROUTE_RICEVUTE_DETTAGLIO_2 ,ROUTE_RICEVUTE_DETTAGLIO_AVVISO, ROUTE_PAGAMENTO_INTEGRATIVO} from "../assets/frontendRouting";
import { PATH_RESTITUZIONE_DI_PARTE , PATH_ESITI_PRIMO_LIVELLO_PEGNO,PATH_ESITI_PRIMO_LIVELLO_PEGNO_CERT,PATH_DATI_PAGAMENTO_INTEGRATIVO , PATH_DOWNLOAD_PAGAMENTO_INTEGRATIVO ,PATH_AVVISI_UNICO, PATH_ESITI_PRIMO_LIVELLO_UNICO ,  PATH_ESITI_SECONDO_LIVELLO_UNICO , PATH_ESITI_SECONDO_LIVELLO_PEGNO, PATH_ESITI_TERZO_LIVELLO_UNICO,PATH_LISTA_ANNI, PATH_DOWNLOAD_FILE_PEGNO,PATH_DOWNLOAD_FILE_PEGNO_CERT, PATH_CHIAMATA_STATOPRATICA , PATH_DOWNLOAD_FILE_UNICO, PATH_ELENCHI_CI, PATH_ESITI_PRIMO_LIVELLO_CI, PATH_DOWNLOAD_FILE_CI, PATH_ESITI_SECONDO_LIVELLO_CI, PATH_ELENCO_CI } from "../config/presdoc-fe-config";
import {  isFromElenchi } from "../assets/utils/queryParams";

class RicevuteStore {

  constructor(root) {   
    this.service = root.service
    this.serviceDownload = root.serviceDownload;
    this.userInfoStore = root.userInfoStore;
    this.routingStore = root.routingStore;
    this.qualificheStore = root.qualificheStore;
    this.initialPagination = {
      start: 0,
      end: 12,
      page:1,
      limit: 12,
      pageCount: 5,
      displayPage: 1
    }
  }

  @observable filtriRicerca = undefined;
  @observable filtriRicercaStored = undefined;
  @observable ricevute = undefined;
  @observable dettaglioSecondoLivello = undefined;
  @observable dettaglioTerzoLivello = undefined;
  @observable loading = false;
  @observable loadingDettaglio = false;
  @observable pagination = this.initialPagination;
  @observable statoPraticaRisultato = undefined;
  @observable avvisi = undefined;
  @observable restituzioneDiParteGiaRichiesta = undefined;
  @observable erroreUtente = undefined;
  @observable idPratica = undefined;
  @observable annoRicerca = undefined;
  @observable listaAnni = [];

 @observable esitiSecondoLivelloUnico = undefined;

  @observable datiPagamentoIntegrativoPrecompilato = undefined;
  

  @action
  updatePagination(start,end,page){
    this.pagination = {
      ...this.pagination,
      start,
      end,
      page
    }
  }

  @action
  initPagination(){
    this.pagination = {
      ...this.initialPagination
    }
  }

  @action
  clearRicevute() {
    this.ricevute = undefined;
  }

  @action
  clearFiltriRicerca() {
    this.filtriRicerca = undefined;
  }

  @action
  esitiPrimoLivello(params){
    return new Promise((resolve, reject) => {
      //this.setLoading(true);
      this.service.doAjax('POST', `${PATH_ESITI_PRIMO_LIVELLO_UNICO}`, params).then(response => {    
        if(response.success) {        
          this.esitiPrimoLivelloUnico = response.result.esitiPrimoLivelloUnico;         
          resolve(response);            
      }
      else{
        //this.setLoading(false);
        reject(response);
       
      }
        
    });
  });
 }

 @action
 esitiSecondoLivello(params){
   return new Promise((resolve, reject) => {
     
     this.service.doAjax('POST', `${PATH_ESITI_SECONDO_LIVELLO_UNICO}`, params).then(response => {    
      if(response.success) {
        //this.setLoading(false); 
      this.esitiSecondoLivelloUnico = response.result.esitiSecondoLivelloUnico   
      resolve(response);                 
     }
     else{
       //this.setLoading(false);
       reject(response);
      
     }
       
   });
 });
}
@action
fetchRicevute(params,tipoPratica,isElenchi){
    this.clearRicevute();
    this.initPagination();
    this.loading = true;
    this.filtriRicerca = {
      ...params
    };
    params.codiceFiscaleRiferimento = this.qualificheStore.codiceFiscaleRiferimento();
    params.identificativoUtenza = this.qualificheStore.qualifica.identificativoUtenza;
    console.log("params.identificativoUtenza: "+ params.identificativoUtenza)
    
    if(tipoPratica === 'MP'){
    this.service.doAjax('POST', `${PATH_ESITI_PRIMO_LIVELLO_PEGNO}`, params).then(response => {  
      this.loading = false;
       if(response.success) {
         this.ricevute = response.result.esitiPrimoLivelloPegno;
       }
    });
    }
    if(tipoPratica === 'UN'){
      this.service.doAjax('POST', `${PATH_ESITI_PRIMO_LIVELLO_UNICO}`, params).then(response => {  
        this.loading = false;
         if(response.success) {
           this.ricevute = response.result.esitiPrimoLivelloUnico;
         }
      });
      }
      if(tipoPratica === 'CP'){
        this.service.doAjax('POST', `${PATH_ESITI_PRIMO_LIVELLO_PEGNO_CERT}`, params).then(response => {  
          this.loading = false;
           if(response.success) {
             this.ricevute = response.result.esitiPrimoLivelloPegnoCertificati;
           }
        });
        }
        if(tipoPratica === 'CI'){
          
          if(isElenchi) {
            params.numEnte = this.qualificheStore.codFiscEnte(); 
            this.service.doAjax('POST', `${PATH_ELENCHI_CI}`, params).then(response => {  
              this.loading = false;
               if(response.success) {
                 this.ricevute = response.result.esitoPrimoLivelloEnte;
                 this.annoRicerca = params.anno
               }
              })
             } else{
              //params.codiceFiscaleRiferimento = "PPGDNL79M64H501Q";
              this.service.doAjax('POST', `${PATH_ESITI_PRIMO_LIVELLO_CI}`, params).then(response => {  
                this.loading = false;
                 if(response.success) {
                   this.ricevute = response.result.esitiPrimoLivelloCI;
                 }
            })
           
          }
          
          }
  }

  
  @action
  loadAndNavigateToSecondoLivello(filtriRicerca, ricevuta , tipoPratica) {
    // quando navigo verso il secondo livello, azzero gli attuali filtri di ricerca e risultati e li memorizzo sulla variabile "stored"
    // se l'utente torna indietro da un secondo livello, i filtri Stored (e risultati) vengono copiati sui filtri che usa la form e l'utente vede la form di ricerca precompilata
    // in questo modo, qualunque altro click all'esterno di "torna indietro", azzera la form.
    
    //  /\
    // /  \
    //  || questo commento lo ha scritto alberto credo... nel frattempo io aggiungo la dinamicità per quanto riguarda il tipoPratica
    this.loadingDettaglio = true;
    if(tipoPratica === 'MP'){
      const params = {
        codiceFiscaleRiferimento : this.qualificheStore.codiceFiscaleRiferimento(),
        identificativoUtenza : this.qualificheStore.qualifica.identificativoUtenza,
        idPratica : ricevuta.idPratica,
        annoPratica : ricevuta.annoPratica
      };

    
    // this.service.doAjax('POST', `${PATH_ESITI_SECONDO_LIVELLO_PEGNO}?idPratica=${ricevuta.idPratica}&annoPratica=${ricevuta.annoPratica}`).then(response => {  
      this.service.doAjax('POST', `${PATH_ESITI_SECONDO_LIVELLO_PEGNO}`, params).then(response => {  
        this.loadingDettaglio = false;
        if(response.success) {
          this.dettaglioSecondoLivello = undefined
          this.filtriRicercaStored = {
            ...filtriRicerca,
            pagination: {
              ...this.pagination
            },
            ricevute: [
              ...this.ricevute
            ]
          }
          this.clearRicevute();
          this.clearFiltriRicerca();
          this.initPagination();
          this.dettaglioSecondoLivello = {
            ricevuta,
            esitiSecondoLivello: response.result.esitiSecondoLivelloPegno
          }
          this.routingStore.push(`${process.env.CONTEXT_PATH}${ROUTE_FROM_PEGNI}${ROUTE_RICEVUTE_DETTAGLIO}`)
        }
      });
    }

    if(tipoPratica === 'UN'){
      const params = {
        codiceFiscaleRiferimento : this.qualificheStore.codiceFiscaleRiferimento(),
        //codiceFiscaleRiferimento : 'STLMLS61D61A669K',
        identificativoUtenza : this.qualificheStore.qualifica.identificativoUtenza,
        idPratica : ricevuta.idPratica,
        }

        this.service.doAjax('POST', `${PATH_ESITI_SECONDO_LIVELLO_UNICO}`, params).then(response => {  
          this.loadingDettaglio = false;
          if(response.success) {
            this.dettaglioSecondoLivello = undefined
            this.filtriRicercaStored = {
              ...filtriRicerca,
              pagination: {
                ...this.pagination
              },
              ricevute: [
                ...this.ricevute
              ]
            }
            this.clearRicevute();
            this.clearFiltriRicerca();
            this.initPagination();
            this.dettaglioSecondoLivello = {
              ricevuta,
              esitiSecondoLivello : response.result.esitiSecondoLivelloUnico
            }
            this.routingStore.push(`${process.env.CONTEXT_PATH}${ROUTE_FROM_UNIMODWEB}${ROUTE_RICEVUTE_DETTAGLIO}`)
          }
        });
      }

        if(tipoPratica === 'CI'){
          const params = {
            codiceFiscaleRiferimento : this.qualificheStore.codiceFiscaleRiferimento(),
            //codiceFiscaleRiferimento : 'PPGDNL79M64H501Q',
            identificativoUtenza : this.qualificheStore.qualifica.identificativoUtenza,
            idPratica : ricevuta.idPratica,
            }
    
            this.service.doAjax('POST', `${PATH_ESITI_SECONDO_LIVELLO_CI}`, params).then(response => {  
              this.loadingDettaglio = false;
              if(response.success) {
                this.dettaglioSecondoLivello = undefined
                this.filtriRicercaStored = {
                  ...filtriRicerca,
                  pagination: {
                    ...this.pagination
                  },
                  ricevute: [
                    ...this.ricevute
                  ]
                }
                this.clearRicevute();
                this.clearFiltriRicerca();
                this.initPagination();
                this.dettaglioSecondoLivello = {
                  ricevuta,
                  esitiSecondoLivello : response.result.esitiSecondoLivelloCI
                }
                this.routingStore.push(`${process.env.CONTEXT_PATH}${ROUTE_FROM_CANCELLAZIONI_IPOTECA}${ROUTE_RICEVUTE_DETTAGLIO}`)
              }
            });
  

    }
  }


  @action
  loadAndNavigateToTerzoLivello(ricevuta , tipoPratica) {
    // quando navigo verso il secondo livello, azzero gli attuali filtri di ricerca e risultati e li memorizzo sulla variabile "stored"
    // se l'utente torna indietro da un secondo livello, i filtri Stored (e risultati) vengono copiati sui filtri che usa la form e l'utente vede la form di ricerca precompilata
    // in questo modo, qualunque altro click all'esterno di "torna indietro", azzera la form.
    
    //  /\
    // /  \
    //  || questo commento lo ha scritto alberto credo... nel frattempo io aggiungo la dinamicità per quanto riguarda il tipoPratica
    if(tipoPratica === 'UN'){
      const params = {
        codiceFiscaleRiferimento : this.qualificheStore.codiceFiscaleRiferimento(),
        //codiceFiscaleRiferimento : 'STLMLS61D61A669K',
        identificativoUtenza : this.qualificheStore.qualifica.identificativoUtenza,
        idPratica : ricevuta.idPratica,
        idAdempimento: ricevuta.progressivoAdempimento
        }

        this.service.doAjax('POST', `${PATH_ESITI_TERZO_LIVELLO_UNICO}`, params).then(response => {  
          this.loadingDettaglio = false;
          if(response.success) {
            this.dettaglioTerzoLivello = undefined
            /*this.filtriRicercaStored = {
              ...filtriRicerca,
              pagination: {
                ...this.pagination
              },
              ricevute: [
                ...this.ricevute
              ]
            }*/
            this.clearRicevute();
            this.clearFiltriRicerca();
            this.initPagination();
            this.restituzioneDiParteGiaRichiesta = false;
            this.dettaglioTerzoLivello = {
              ricevuta,
              esitiTerzoLivello : response.result.esitiTerzoLivelloUnico
              
            }
            this.routingStore.push(`${process.env.CONTEXT_PATH}${ROUTE_FROM_UNIMODWEB}${ROUTE_RICEVUTE_DETTAGLIO_2}`)
          }
        });
  

    }
  }

  @action
  loadAndNavigateToAvvisi(filtriRicerca, dettaglioIILivello , tipoPratica) {
    // quando navigo verso il secondo livello, azzero gli attuali filtri di ricerca e risultati e li memorizzo sulla variabile "stored"
    // se l'utente torna indietro da un secondo livello, i filtri Stored (e risultati) vengono copiati sui filtri che usa la form e l'utente vede la form di ricerca precompilata
    // in questo modo, qualunque altro click all'esterno di "torna indietro", azzera la form.
    
    //  /\
    // /  \
    //  || questo commento lo ha scritto alberto credo... nel frattempo io aggiungo la dinamicità per quanto riguarda il tipoPratica
    this.loadingDettaglio = true;
    if(tipoPratica === 'UN'){
      const params = {
        cfRiferimento : this.qualificheStore.codiceFiscaleRiferimento(),
        //cfRiferimento : 'STLMLS61D61A669K',
        identificativoUtenza : this.qualificheStore.qualifica.identificativoUtenza,
        idPratica : dettaglioIILivello.idPratica,
        primoNumRep : dettaglioIILivello.primoNumeroRepertorio,
        secondoNumRep : dettaglioIILivello.secondoNumeroRepertorio
      };

    
    // this.service.doAjax('POST', `${PATH_ESITI_SECONDO_LIVELLO_PEGNO}?idPratica=${ricevuta.idPratica}&annoPratica=${ricevuta.annoPratica}`).then(response => {  
      this.service.doAjax('POST', `${PATH_AVVISI_UNICO}`, params).then(response => {  
        this.loadingDettaglio = false;
        if(response.success) {
          this.avvisoPagamento = undefined
  
          this.clearRicevute();
          this.clearFiltriRicerca();
          this.initPagination();
          this.avvisi = {
            dettaglioIILivello,
            avvisoPagamento: response.result.avvisoPagamento
          }
          this.routingStore.push(`${process.env.CONTEXT_PATH}${ROUTE_FROM_UNIMODWEB}${ROUTE_RICEVUTE_DETTAGLIO_AVVISO}`)
        }
      });
    }
  
  }
  

  @action
  backToPrimoLivello(tipoPratica) {
    if(this.filtriRicercaStored) {
      this.pagination = {
        ...this.filtriRicercaStored.pagination
      }
      this.filtriRicerca = {
        ...this.filtriRicercaStored
      }
      this.ricevute = [...this.filtriRicercaStored.ricevute]
    }
    this.dettaglioSecondoLivello = undefined;
    this.routingStore.push(`${process.env.CONTEXT_PATH}${this.ottieniRouteApplicazione(tipoPratica)}${ROUTE_RICEVUTE}`);
  }

  @action
  backToSecondoLivello(tipoPratica) {
    this.dettaglioTerzoLivello = undefined;
    this.avvisi = undefined
    this.routingStore.push(`${process.env.CONTEXT_PATH}${this.ottieniRouteApplicazione(tipoPratica)}${ROUTE_RICEVUTE_DETTAGLIO}`);
  }

  @action
  backToAvvisi(tipoPratica) {
    this.datiPagamentoIntegrativoPrecompilato= undefined
    this.routingStore.push(`${process.env.CONTEXT_PATH}${this.ottieniRouteApplicazione(tipoPratica)}${ROUTE_RICEVUTE_DETTAGLIO}`);
  }

  /*downloadFile(fileMetaData) {
    this.serviceDownload.doAjax('POST', `${PATH_DOWNLOAD_FILE_PEGNO}`, fileMetaData);
  }*/

   ottieniRouteApplicazione = tipoPratica =>{
    let routeApplicazione = ''
    if(tipoPratica==='UN')
       routeApplicazione =  ROUTE_FROM_UNIMODWEB
    else if(tipoPratica ==='MP') //NON ESISTE UN LIVELLO INFERIORE A LIVELLO GERARCHICO AL SECONDO NEI PEGNI MA LASCIO COMUNQUE L'ELSE IF
    routeApplicazione = ROUTE_FROM_PEGNI
    else if(tipoPratica ==='CP') //NON ESISTE UN LIVELLO INFERIORE A LIVELLO GERARCHICO AL SECONDO NEI PEGNI MA LASCIO COMUNQUE L'ELSE IF
    routeApplicazione = ROUTE_FROM_PEGNI_CERTIFICATI
    else if(tipoPratica ==='CI') //NON ESISTE UN LIVELLO INFERIORE A LIVELLO GERARCHICO AL SECONDO NEI PEGNI MA LASCIO COMUNQUE L'ELSE IF
    routeApplicazione = ROUTE_FROM_CANCELLAZIONI_IPOTECA
    return routeApplicazione
  }
  
  downloadFile(params) {
    params.codiceFiscaleRiferimento = this.qualificheStore.codiceFiscaleRiferimento(); 
    params.identificativoUtenza =  this.qualificheStore.qualifica.identificativoUtenza;
    this.serviceDownload.doAjax('POST', `${this.qualificheStore.tipoPratica === 'MP'? PATH_DOWNLOAD_FILE_PEGNO
                                          :this.qualificheStore.tipoPratica === 'UN'? PATH_DOWNLOAD_FILE_UNICO
                                          :this.qualificheStore.tipoPratica === 'CP'? PATH_DOWNLOAD_FILE_PEGNO_CERT
                                          :this.qualificheStore.tipoPratica === 'CI'? PATH_DOWNLOAD_FILE_CI
                                          : undefined}`, params);
  }

  fornituraOnDemandCI(params) {
    params.ente = this.qualificheStore.codFiscEnte(); 
    
    params.identificativoUtenza =  this.qualificheStore.qualifica.identificativoUtenza;
    this.serviceDownload.doAjax('POST', `${PATH_ELENCO_CI}`, params);
  }
  
  fetchDatiPagamentoIntegrativoPrecompilato(params) {
    params.cfRiferimento = this.qualificheStore.codiceFiscaleRiferimento(),
    //params.cfRiferimento = 'STLMLS61D61A669K',
  this.service.doAjax('POST', `${PATH_DATI_PAGAMENTO_INTEGRATIVO}`, params).then(response => {  
    if(response.success) {
      this.datiPagamentoIntegrativoPrecompilato = undefined

     
      this.datiPagamentoIntegrativoPrecompilato = {
        codiceAtto: response.result.codiceAtto,  
        importoDebito: response.result.importoDebito
      }
      this.routingStore.push(`${process.env.CONTEXT_PATH}${ROUTE_FROM_UNIMODWEB}${ROUTE_PAGAMENTO_INTEGRATIVO}`)
    }
  });
}

restituzioneDiParte(params){
  //params.cfRiferimento = 'STLMLS61D61A669K'
  //params.richiedenteRestituzioneNota = 'STLMLS61D61A669K'
  params.identificativoUtenza = this.qualificheStore.qualifica.identificativoUtenza,

  params.cfRiferimento = this.qualificheStore.codiceFiscaleRiferimento(),
  params.richiedenteRestituzioneNota = this.qualificheStore.codiceFiscaleRiferimento(),

  this.serviceDownload.doAjax('POST',`${PATH_RESTITUZIONE_DI_PARTE}`, params).then(response => {  
      
    if(response.success) {
      this.restituzioneDiParteGiaRichiesta = true; 
    }
  });

}


  chiamataStatoPratica(ricevuta) {
    const params = {
      cf : this.qualificheStore.codiceFiscaleRiferimento(),
      id_sequence : ricevuta.idPratica,
      identificativoTitolo : ricevuta.numRep,
      numeroPratica : ricevuta.protocollo + "/" + ricevuta.annoProtocollo
    };

    this.service.doAjax('POST', `${PATH_CHIAMATA_STATOPRATICA}`, params).then(response => {  
      this.loading = false;
      if(response.success) {
        this.statoPraticaRisultato = {
          dataRicezione : response.result.dataRicezione,
          statoLavorazione : response.result.statoLavorazione,
          esito : response.result.esito
        }
      }
      else {
        this.statoPraticaRisultato = {
          dataRicezione : "",
          statoLavorazione : "",
          esito : 9
        }
      }
    });
  }

  @action
fetchListaAnni(){
  const numEnte =  this.qualificheStore.codFiscEnte();  //SCOLPITO ;
  this.service.doAjax('GET', `${PATH_LISTA_ANNI}numEnte=${numEnte}`).then(response => {  
    if(response.success) {
      this.listaAnni = response.result.map(item => {
        return {
         optionValue: item,
         optionLabel: item
         
       }
    });  
  }
})
}


  downloadPagamentoIntegrativo(params,callback){
    
    this.serviceDownload.doAjax('POST',`${PATH_DOWNLOAD_PAGAMENTO_INTEGRATIVO}`, params).then(response => {  
      
      if(response.success) {
        
      }
      callback && callback(response);
    });

  }

  messaggioErrore(messaggioErrore){
  this.erroreUtente = messaggioErrore;
}
}

export default RicevuteStore;